$(() => {
  $('.js-header-menu').each(function () {
    const $menu = $(this);

    // panel 高さを初回に一度だけ固定
    const $panel = $menu.find('.mc-header-menu__panel');
    const fixedHeight = $panel.outerHeight();
    $menu.find('.js-header-menu-subpanel').css({ height: fixedHeight + 'px' });

    const isPC = () => $('body').hasClass('pc');
    const isSmartphone = () => $('body').hasClass('smartphone'); // ← 修正！！

    const closeAll = () => {
      $menu.find('.active, .is-open').removeClass('active is-open');
    };

    /* ============================
       PC：layer-1 hover → subpanel表示
       ============================ */
    $menu.on('mouseenter', '.js-header-menu-layer-1', function () {
      if (!isPC()) return;

      const id = $(this).data('subpanel-id');
      if (!id) return;

      closeAll();

      $(this).addClass('active');
      $menu.find('#' + id).addClass('is-open');
    });

    /* ============================
       PC：subpanel hover → active 維持
       ============================ */
    $menu.on('mouseenter', '.js-header-menu-subpanel', function () {
      if (!isPC()) return;

      const parentId = $(this).data('parent-id');
      if (!parentId) return;

      $menu.find('.js-header-menu-layer-1[data-subpanel-id="' + parentId + '"]')
           .addClass('active');
    });

    /* ============================
       PC：メニュー全体から出たら閉じる
       ============================ */
    $menu.on('mouseleave', function () {
      if (!isPC()) return;
      closeAll();
    });


    /* ==============================
       SP：root click → panel 開閉
       ============================== */
    $menu.find('.js-header-menu-root').on('click', function (e) {
      if (!isSmartphone()) return;
      e.preventDefault();

      const $panel = $menu.find('.mc-header-menu__panel');

      $panel.stop(true, true).slideToggle(200, function () {
        $panel.toggleClass('is-open', $panel.is(':visible'));
      });
    });

    /* ===============================================
       SP：layer-1 click → subpanel（2階層）アコーディオン
       =============================================== */
    $menu.find('.js-header-menu-layer-1').on('click', function (e) {
      if (!isSmartphone()) return;
      e.preventDefault();

      const id = $(this).data('subpanel-id');
      if (!id) return;

      const $newSub = $menu.find('#' + id);
      const $opened = $menu.find('.mc-header-menu__subpanel.is-open');

      // 他を閉じる
      if ($opened.length && $opened.attr('id') !== id) {
        $opened.stop(true, true).slideUp(200, function () {
          $opened.removeClass('is-open').detach();
        });
      }

      // 新しい subpanel を移動
      if (!$newSub.parent().is($(this))) {
        $(this).append($newSub);
      }

      // toggle
      $newSub.stop(true, true).slideToggle(100, function () {
        $newSub.toggleClass('is-open', $newSub.is(':visible'));
      });
    });

    /* ===============================================
       SP：2階層リンククリック → 遷移
       =============================================== */
    $menu.find('.mc-header-menu__layer-2-text').on('click', function (e) {
      if (!isSmartphone()) return;
      e.stopPropagation();
    });
  });
});
